import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Resources', path: '/resources' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-main">
      <nav className="header-container">
        <Link to="/" className="header-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_ca-piyush-gupta/artifacts/yae02nne_CA%20India%20Logo-%20-%20Copy.jpg" 
            alt="CA India Logo" 
            className="logo-img"
          />
          <div className="logo-text">
            <span className="logo-title">CA Piyush Gupta</span>
            <span className="logo-subtitle">Gupta Piyush & Company</span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="header-nav desktop-nav">
          {navigation.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
            >
              {item.name}
            </Link>
          ))}
          <a href="tel:+916396550622" className="header-phone-btn">
            <Phone size={18} />
            <span>+91-6396550622</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav">
          {navigation.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
          <a 
            href="tel:+916396550622" 
            className="mobile-phone-btn"
            onClick={() => setIsMenuOpen(false)}
          >
            <Phone size={18} />
            <span>+91-6396550622</span>
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
